import React from "react";
import styled from "styled-components";
import { useWeb3React } from "@web3-react/core";
import { injected } from "../../config/walletConnectors";

import NavBg from "../../assets/nav_bg.png";
import LSS_Logo from "../../assets/lss.svg";
import LSS_Logo_small from "../../assets/lss_small.svg";
import Button from "../styled/Button";
import { Link } from "react-router-dom";
import { ChainData } from "../../config/web3";
const Gradient = styled.div`
  background: linear-gradient(
    189.88deg,
    #000000 5.52%,
    rgba(0, 0, 0, 0) 71.49%
  );
  opacity: 0.9;
`;

const NavBarWrapper = styled(Gradient)`
  background-image: url(${NavBg});
  background-size: cover;
`;

const LosslessLogo = styled.img`
  width: 150px;
  content: url(${LSS_Logo});
  @media only screen and (max-width: 800px) {
    content: url(${LSS_Logo_small});
    width: 70px;
  }
`;

const NavBarContainer = styled.div`
  display: flex;
  align-items: center;
  max-width: 1280px;
  margin-right: auto;
  margin-left: auto;
  padding-right: 48px;
  padding-left: 48px;
  padding-top: 20px;
  padding-bottom: 20px;
  justify-content: space-between;

  @media (max-width: 768px) {
    padding-right: 24px;
    padding-left: 24px;
  }
`;

const AddressInfo = styled.div`
  display: flex;
  align-items: center;
  background-color: ${(props) => props.theme.colors.lightGray};
  border-radius: 4px;
  padding: 5px;
  gap: 10px;
`;

const getChainName = (chainId: number) => {
  const chainName = ChainData[chainId]?.name;
  if (!chainName || !chainId) {
    return "Unsupported Network";
  }

  return chainName;
};

const NavBar = () => {
  const { activate, account, chainId } = useWeb3React();

  const activateWallet = () => {
    activate(injected);
  };

  return (
    <NavBarWrapper>
      <NavBarContainer>
        <Link to="/">
          <LosslessLogo />
        </Link>
        {account && chainId ? (
          <AddressInfo>
            {account.substring(0, 6)}...{account.substring(38)}
            <strong>
              <span>{getChainName(chainId)}</span>
            </strong>
          </AddressInfo>
        ) : (
          <Button onClick={() => activateWallet()}>Connect Wallet</Button>
        )}
      </NavBarContainer>
    </NavBarWrapper>
  );
};

export default NavBar;
